import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=cfdb32fe&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfdb32fe')) {
      api.createRecord('cfdb32fe', component.options)
    } else {
      api.reload('cfdb32fe', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=cfdb32fe&", function () {
      api.rerender('cfdb32fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25pId3rCF4LEt/JS/comp/ImgFallback.vue"
export default component.exports